<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { hfarmCorporateTileMixin } from "../../modules/hfarm_corporate_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, hfarmCorporateTileMixin],
  data: function() {
    return {
      courseInfo: [
        {key: "duration", icon:"fa-calendar-alt"},
        {key: "formula", icon:"fa-clock"},
        {key: "location", icon:"fa-map-marker-alt"}
      ]
    }
  },
  methods: {
    getTagLabel(tagLabel) {
      const tags = this.content[tagLabel];
      return tags && tags.map( tag => {
        return get(this.getContent(tag), "title", "")
      }).join(', ')
    },
    getTagIcon(tagKey) {
      const tags = this.content[tagKey];
      if (tags && tags.length > 0) {
        // always keep the first element
        return get(this.getContent(tags[0]), "icon", "fa-tag");
      }

      return "fa-tag";
    }
  },
  computed: {
    footerTags() {
      if (!this.content.footer_tags) {
        // fallback to course info footer for backward compatibility
        return this.courseInfo;
      }

      return this.content.footer_tags.split(',').map(key => {
        return {key, icon: this.getTagIcon(key)}
      })
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentType]" class="w-100 h-100" :style="theme">
    <a
      :href="tileUrl"
      :target="getTarget(content.url)" 
      class="w-100 h-100 deco-none bg-transition text-white" 
      :class="content.isotope_size"
      :id="`tile-search-${contentId}`"
      :style="{'cursor': content.url || getContentURL(content) ? 'pointer' : 'default', 'background-color': content.background_color}"
      tile-search-component
    >
      <div class="card text-dark h-100 px-3">
        <div class="card-header font-weight-bold bg-white px-0 text-uppercase">{{getTagLabel('category')}}</div>
        <div class="card-body px-0">
          <h3 class="card-title mb-0">{{content.title}}</h3>
        </div>
        <div class="card-footer bg-white px-0">
          <ul class="list-group list-group-flush">
            <li v-for="tag in footerTags" :key="tag.key" class="list-group-item px-0 py-1 d-flex align-items-center">
              <i :class="tag.icon" class="fas mr-2"></i>
              <span class="text-capitalize">{{ft(`globals.tag.${tag.key}`)}}:</span>
              <span class="text-truncate ml-1 font-weight-bold">{{getTagLabel(tag.key)}}</span>
            </li>
          </ul>
        </div>
      </div>
    </a>
  </div>
</template>

<style lang="scss" scoped>
[tile-search-component] {
  .card {
    border-radius: 0;
    border: none;
    border-top: 4px solid var(--theme-border-color);

    &-header {
      color: var(--theme-color);
      font-size: $h5-font-size;
    }

    &-body {
      min-height: 120px;
    }

    &-title {
      font-weight: 800;
      color: var(--theme-color);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  .list-group-item {
    border: 0;
    font-size: $h5-font-size;
    
    i {
      font-size: $font-size-base;
      width: $font-size-base;
      display: inline-flex;
      justify-content: center;
    }
  }
}
</style>
